import React from 'react'

import { Navigate, Outlet } from 'react-router-dom'
import useUserData from 'src/hooks/useUserData'

const useAuth = () => {
  const user: any = useUserData()
  if (user) {
    return true
  } else {
    return false
  }
}

const ProtectedRoutes = (props: any) => {
  const auth = useAuth()

  return auth ? <Outlet /> : <Navigate to="/accounts/login" />
}

export default ProtectedRoutes
